<template>
  <div class="container-fluid">
    <div class="col-xl-12 col-lg-12 col-md-12">
      <div
        class="page-content__header-description"
        style="display: flex; margin-bottom: 20px"
      >
        <h2 style="flex: 1">Customer Onboarding Tracker</h2>
      </div>
      <div class="main-container onboarding-tracker-table-height">
        <el-input
          style="max-width: 200px"
          placeholder="Type something"
          prefix-icon="el-icon-search"
          v-model="searchTerm"
        ></el-input>
        <vue-good-table
          :lineNumbers="true"
          :columns="fields"
          :rows="getUsers"
          :isLoading="isLoadingVGT"
          :select-options="selectOption"
          :search-options="{
            enabled: true,
            searchFn: searchTable,
            externalQuery: searchTerm
          }"
          :pagination-options="{ enabled: true }"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'fullName'">
              {{ props.row.fullName ? props.row.fullName : "----" }}
            </span>

            <span v-if="props.column.field == 'completionDate'">
              <span v-if="props.row.completionDate">
                {{ props.row.completionDate | formatDate }}
              </span>
              <span v-else>
                <img class="center-svg" :src="tickOrCross('N')" />
              </span>
            </span>

            <span v-if="props.column.field == 'startDate'"
              ><span v-if="props.row.startDate">
                {{ props.row.startDate | formatDate }}
              </span>
              <span v-else>
                <img class="center-svg" :src="tickOrCross('N')" />
              </span>
            </span>

            <span v-if="props.column.field == 'paymentType'">
              <span v-if="props.row.paymentType" class="center-svg">
                {{ props.row.paymentType }}
              </span>
              <span v-else>
                <img class="center-svg" :src="tickOrCross('N')" />
              </span>
            </span>

            <span v-if="props.column.field == 'productType'">
              <span v-if="props.row.productType">
                {{ props.row.productType }}
              </span>
              <span v-else>
                <img class="center-svg" :src="tickOrCross('N')" />
              </span>
            </span>

            <span v-if="props.column.field == 'signedAgreement'">
              <img
                class="center-svg"
                :src="tickOrCross(props.row.signedAgreement ? 'Y' : 'N')"
              />
            </span>

            <span v-if="props.column.field == 'paymentTenure'">
              <span v-if="props.row.paymentTenure" class="center-svg">
                {{ props.row.paymentTenure }}
              </span>
              <span v-else>
                <img class="center-svg" :src="tickOrCross('N')" />
              </span>
            </span>

            <span v-if="props.column.field == 'statementPassed'">
              <img
                class="center-svg"
                :src="tickOrCross(props.row.statementPassed ? 'Y' : 'N')"
              />
            </span>

            <span v-if="props.column.field == 'kycUploadComplete'">
              <img
                class="center-svg"
                :src="tickOrCross(props.row.kycUploadComplete ? 'Y' : 'N')"
              />
            </span>

            <span v-if="props.column.field == 'depositSuccessful'">
              <img
                class="center-svg"
                :src="tickOrCross(props.row.depositSuccessful ? 'Y' : 'N')"
              />
            </span>

            <span v-if="props.column.field == 'installationStatus'">
              <img
                class="center-svg"
                :src="tickOrCross(props.row.installationStatus ? 'Y' : 'N')"
              />
            </span>

            <span v-if="props.column.field == 'installationDate'">
              <span v-if="props.row.installationDate">
                {{ props.row.installationDate | formatDate }}
              </span>
              <span v-else>
                <img class="center-svg" :src="tickOrCross('N')" />
              </span>
            </span>
          </template>

          <template slot="pagination-bottom" slot-scope="props">
            <grey-pagination
              :total="props.total"
              :pageChanged="props.pageChanged"
              :perPageChanged="props.perPageChanged"
            ></grey-pagination>
          </template>
        </vue-good-table>
      </div>
    </div>
    <vk-offcanvas flipped overlay stuck :show.sync="editOffCanvas">
      <div style>
        <vk-offcanvas-close @click="editOffCanvas = false"></vk-offcanvas-close>
        <h3>Edit</h3>
        <hr />
        <el-form
          class="form"
          ref="form"
          :model="form"
          label-width="150px"
          label-position="left"
        >
          <el-form-item class="form-item" label="Name">
            <el-input
              style="width: 100%"
              id="customer-name"
              v-model="regDataParams.name"
              :min="1"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="prim​​ary"
              class="customer-btn"
              @click="onSubmit()"
              >{{ isLoading ? "Loading..." : "Edit" }}</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </vk-offcanvas>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import { Offcanvas, OffcanvasClose } from "vuikit/lib/offcanvas";
import {
  Autocomplete,
  Form,
  FormItem,
  Radio,
  RadioGroup,
  RadioButton
} from "element-ui";
import moment from "moment";
moment.updateLocale("en", {
  monthsShort: "jan_feb_mar_apr_may_june_july_aug_sept_oct_nov_dec".split("_")
});

const items = [];
export default {
  components: {
    "vk-offcanvas": Offcanvas,
    "vk-offcanvas-close": OffcanvasClose,
    "el-autocomplete": Autocomplete,
    "el-form": Form,
    "el-form-item": FormItem,
    "el-radio": Radio,
    "el-radio-group": RadioGroup,
    "el-radio-button": RadioButton
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data() {
    return {
      searchTerm: "",
      editOffCanvas: false,
      isLoading: false,
      isLoadingVGT: true,
      regDataParams: {
        name
      },
      selectOption: {
        enabled: false
      },
      items: items,
      fields: [
        {
          field: "fullName",
          label: "Customer Name",
          sortable: "true"
        },
        {
          field: "startDate",
          label: "Onboarding Start Date",
          sortable: "true"
        },
        {
          field: "completionDate",
          label: "Completion Date",
          sortable: "true"
        },
        {
          field: "paymentType",
          label: "Chosen Payment Type",
          sortable: "true"
        },
        {
          field: "productType",
          label: "Product Type",
          sortable: "true"
        },
        {
          field: "signedAgreement",
          label: "Signed Agreement",
          sortable: "true"
        },
        {
          field: "paymentTenure",
          label: "Payment Tenure",
          sortable: "true"
        },
        {
          field: "statementPassed",
          label: "Statement Passed",
          sortable: "true"
        },
        {
          field: "kycUploadComplete",
          label: "KYC Upload",
          sortable: "true"
        },
        {
          field: "depositSuccessful",
          label: "Deposit Successful?",
          sortable: "true"
        },
        {
          field: "installationStatus",
          label: "Installation Status",
          sortable: "true"
        },
        {
          field: "installationDate",
          label: "Installation Date",
          sortable: "true"
        }
      ],
      getUsers: "",
      currentPage: 1,
      details: "UserDetails",
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalInfo: {
        title: "",
        content: ""
      }
    };
  },
  computed: {
    ...mapGetters(["getUserById", "getDummy", "getUserSession"]),
    sortOptions() {
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return {
            text: f.label,
            value: f.key
          };
        });
    }
  },
  methods: {
    toggleIsLoading() {
      this.isLoading = !this.isLoading;
    },
    tickOrCross(e) {
      if (e == "Y") {
        return require("../../../assets/img/checked.png");
      } else {
        return require("../../../assets/img/error.png");
      }
    },
    searchTable(row, col, cellValue, searchTerm) {
      return (
        Object.values(row)
          .join("<%>")
          .toLowerCase()
          .indexOf(searchTerm.toLowerCase()) > -1
      );
    },
    toggleEditCanvas(data) {
      this.regDataParams = data;
      this.editOffCanvas = !this.editOffCanvas;
    },
    formatDate(date) {
      return moment(date).format("Do MMM YYYY");
    },
    init() {
      const httpUtils = this.$httpUtils;
      let url = `/onboardingStates/getUsersDataWithStatus`;

      httpUtils.instance
        .get(url)
        .then(response => {
          console.log("onboard-tracker", response.data);
          this.getUsers = response.data;
          this.isLoadingVGT = false;
        })
        .catch(error => {
          console.log("tracker error", error);
          this.showErrorMsg({ message: "Error occured at our end!" });
        });
    }
  },
  async mounted() {
    this.init();
  }
};
</script>

<style scoped>
.card-title {
  font-size: 2.6rem;
}

.center-svg {
  display: flex;
  margin: 0px auto;
  width: 15px;
}

table th,
table th span {
  font-size: 0.7em;
}
.onboarding-tracker-table-height {
  height: calc(100vh - 240px);
}
</style>



// WEBPACK FOOTER //
// src/components/pages/onboardingTracker/OnboardingTracker.vue